export default {"src":"/_next/static/media/outrun.80c2c410.svg","height":55,"width":74};